@if (loading) {
  <div class="loader"></div>
}
<div class="left-modal full">
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <div class="L-4 M-8 S-10 centered columns">
        <h1>{{'Edit continuity image' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
          <div class="row">
            <div class="L-12 M-12 S-12 columns" style="padding-bottom: 6px;">
              <label>{{'Department' | translate}}**</label>
              <app-dropdown
                [(appModel)]="formData.department_id"
                [list]="viewData.departments"
                [value]="'id'"
                [name]="'department_name'"
                [backTranslate]="true"
              ></app-dropdown>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns" style="padding-bottom: 6px;">
            <div class="L-3 M-3 S-3 columns">
              <div class="imageConteiner" imageSize>
                <img [src]="continuityImage.image_url" alt="" imageLoader (load)="_gS.loadImage()">
              </div>
            </div>
            <div class="L-9 M-9 S-9 columns">
              <!-- Character -->
              @if (type=='character') {
                <div class="L-9 M-9 S-9 columns">
                  <label>{{'Characters' | translate}}**</label>
                  <app-dropdown
                    [(appModel)]="formData.character_id"
                    (appModelChange)="checkDays($event);"
                    [list]="viewData.characters"
                    [value]="'id'"
                    [name]="'character_name'"
                  ></app-dropdown>
                </div>
                <div class="L-3 M-3 S-3 columns">
                  <label>{{'Day' | translate}}**</label>
                  <app-dropdown
                    [(appModel)]="formData.day_of_history"
                    [list]="filteredDays"
                    [value]="'day_of_history'"
                    [name]="'day_of_history'"
                    [showEmpty]="true"
                    [placeholder]="'None'"
                  ></app-dropdown>
                </div>
              }
              <!-- Set -->
              @if (type == 'set') {
                <div class="L-12 M-12 S-12 columns">
                  <label>{{'Location' | translate}}**</label>
                  <app-dropdown
                    [(appModel)]="formData.location_id"
                    (appModelChange)="checkSets()"
                    [list]="viewData.locations"
                    [value]="'id'"
                    [name]="'location_name'"
                  ></app-dropdown>
                </div>
                @if (formData.location_id) {
                  <div class="L-12 M-12 S-12 columns">
                    <label>{{'Set' | translate}}**</label>
                    <app-dropdown
                      [(appModel)]="formData.location_set_id"
                      [list]="filteredSets"
                      [value]="'id'"
                      [name]="'set_name'"
                    ></app-dropdown>
                  </div>
                }
              }
              @if (type == 'scenes') {
                <div class="L-12 M-12 S-12 columns">
                  <label>{{'Scene' | translate}}**</label>
                  <app-dropdown
                    [(appModel)]="formData.scenes_id"
                    (appModelChange)="changeChapterScene(formData)"
                    [list]="viewData.scenes"
                    [value]="'id'"
                    [name]="'chapter_scene'"
                  ></app-dropdown>
                </div>
              }
              <div class="L-12 M-12 S-12 columns">
                <label>{{'Observation' | translate}}</label>
                <input type="text" name="tittle" [(ngModel)]="formData.tittle" placeholder="{{'Insert' | translate}}">
              </div>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Save' | translate}}" [attr.disabled]="form.invalid || pendingData()?'':null">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    </div>
  }

</div>
